import React from 'react';
import Chart from "react-google-charts";

export const BarChartGoogle = (props) => {

return (

<Chart
  width={'100%'}
  height={(props.data.length >1 ?props.data.length * 20 : 120).toString() + "px"}
  chartType="BarChart"
  loader={<div>Loading Chart</div>}
  data={props.data}
  options={{
    chartArea: { width: '50%' ,  right: 0},
    vAxis : { textStyle : {fontSize: 9 }},

    bar:{groupWidth: "70%"},
    // "hAxis":{showTextEvery:1},
    isStacked: true,
    colors: [props.color, 'grey'],
    legend: { position: 'none' },
    tooltip: { trigger: 'none' }
  }}
/>

);
}